import React, { useEffect } from 'react'
import AppPageComponent from '@components/page/appPage.component'
import PageHeaderComponent from '@components/page/pageHeader.component'
import PageBodyComponent from '@components/page/pageBody.component'
import PlaylistListComponent from '@components/playlist/playlistList.component'
import { useDispatch, useSelector } from 'react-redux'
import {
  fetchAllPlaylists,
  PlaylistModel,
  selectAllPlaylists,
  selectPlaylistLoading,
} from '@store/slices/playlist.slice'
import { AppDispatch } from '@store/store'
import { DjangoFilter, SortOrder } from '@store/slices/generic.slice'

const DashboardPage: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>()
  const recentPlaylists = useSelector(selectAllPlaylists)
  const isPlaylistLoading = useSelector(selectPlaylistLoading)

  useEffect(() => {
    if (!isPlaylistLoading) fetchRecentPlaylists()
  }, [])

  const fetchRecentPlaylists = () => {
    const filter = new DjangoFilter<PlaylistModel>()
    filter.setLimit(10)
    filter.setOffset(0)
    filter.setSortOrder(SortOrder.DESCENDING)
    filter.addSortField('updated_at')
    dispatch(fetchAllPlaylists(filter))
  }

  return (
    <AppPageComponent>
      <PageHeaderComponent>
        <h3 className="my-2">Nedávno upravené playlisty</h3>
      </PageHeaderComponent>
      <PageBodyComponent>
        <div className="my-2">
          <PlaylistListComponent
            playlistIds={recentPlaylists
              .sort(
                (a, b) =>
                  new Date(b.updatedAt).getTime() -
                  new Date(a.updatedAt).getTime()
              )
              .map((playlist) => playlist.id)}
          ></PlaylistListComponent>
        </div>
      </PageBodyComponent>
    </AppPageComponent>
  )
}
export default DashboardPage
